import React from 'react';
import { TextInput, required } from 'react-admin';
import PropTypes from 'prop-types';

import { Grid } from '@material-ui/core';

const ClientForm = ({ nameLabel, themeLabel }) => (
  <Grid container spacing={3}>
    <Grid item xs={12} sm={12} md={4}>
      <TextInput
        source="name"
        label={nameLabel}
        fullWidth
        validate={required()}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={4}>
      <TextInput
        defaultValue="default"
        fullWidth
        label={themeLabel}
        disabled
        source="theme"
        validate={required()}
      />
    </Grid>
  </Grid>
);

ClientForm.propTypes = {
  nameLabel: PropTypes.string.isRequired,
  themeLabel: PropTypes.string.isRequired,
};

export default ClientForm;
